import { render, staticRenderFns } from "./deco-corners.vue?vue&type=template&id=321e8e69&scoped=true"
import script from "./deco-corners.vue?vue&type=script&lang=js"
export * from "./deco-corners.vue?vue&type=script&lang=js"
import style0 from "./deco-corners.vue?vue&type=style&index=0&id=321e8e69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e8e69",
  null
  
)

export default component.exports